/**
 * Browser Fingerprinting Service
 * Uses FingerprintJS to generate unique device identifiers
 * Used to prevent banned users from creating new accounts
 */

import FingerprintJS from '@fingerprintjs/fingerprintjs';

class FingerprintService {
  private fpPromise: Promise<any> | null = null;

  /**
   * Initialize FingerprintJS
   * Loads the library and prepares it for use
   */
  async init() {
    if (!this.fpPromise) {
      this.fpPromise = FingerprintJS.load();
    }
    return this.fpPromise;
  }

  /**
   * Get browser fingerprint
   * Returns a unique identifier for this browser/device combination
   * 
   * @returns {Promise<string>} Fingerprint ID or empty string if failed
   */
  async getFingerprint(): Promise<string> {
    try {
      const fp = await this.init();
      const result = await fp.get();
      return result.visitorId;
    } catch (error) {
      console.error('Failed to generate fingerprint:', error);
      // Return empty string if fingerprinting fails
      // Don't block user experience
      return '';
    }
  }

  /**
   * Get detailed fingerprint components (for debugging)
   * Includes confidence score and all components used
   * 
   * @returns {Promise<any>} Detailed fingerprint data or null if failed
   */
  async getFingerprintDetails(): Promise<any> {
    try {
      const fp = await this.init();
      const result = await fp.get();
      return {
        visitorId: result.visitorId,
        confidence: result.confidence,
        components: result.components,
      };
    } catch (error) {
      console.error('Failed to get fingerprint details:', error);
      return null;
    }
  }
}

export const fingerprintService = new FingerprintService();

